import React, { useState } from "react";
import { FaStar, FaQuoteRight, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { SiInfosys } from "react-icons/si";
import { motion, AnimatePresence } from "framer-motion";
import { MdBusinessCenter } from "react-icons/md";

const companies = [
    {
        name: "Infosys",
        icon: <SiInfosys className="text-xl" />,
        person: "Anand Sharma",
        designation: "Project Head, Infosys",
        quote: "One of the world's leading technology consulting firms",
    },
    {
        name: "HeyMate",
        icon: <MdBusinessCenter className="text-xl" />,
        person: "Priya Desai",
        designation: "COO, HeyMate",
        quote: "A mobile-first gig economy platform driving smart workforce solutions",
    },
    // {
    //     name: "Rao Associate",
    //     icon: <MdBusinessCenter className="text-xl" />,
    //     person: "Rakesh Rao",
    //     designation: "Founder, Rao Associate",
    //     quote: "A strategic consulting firm focused on global talent and operations",
    // },
    // {
    //     name: "Radyas Inc.",
    //     icon: <MdBusinessCenter className="text-xl" />,
    //     person: "Neha Verma",
    //     designation: "Manager, Radyas Inc.",
    //     quote: "A cutting-edge provider of digital solutions and product development",
    // },
];

const CompanyTestimonial = () => {
    const [selected, setSelected] = useState(0);
    const company = companies[selected];

    const nextTestimonial = () => {
        setSelected((prev) => (prev === companies.length - 1 ? 0 : prev + 1));
    };

    const prevTestimonial = () => {
        setSelected((prev) => (prev === 0 ? companies.length - 1 : prev - 1));
    };

    return (
        <div className="bg-gray-100 lg:h-auto flex items-center justify-center p-6 mb-6">
            <div className="bg-white rounded-xl shadow-lg max-w-7xl w-full p-8">
                {/* Stats Section at Top */}
                {/* Header Section */}
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
                        Trusted by innovative <span className="text-blue-600">tech leaders worldwide</span>
                    </h2>
                    <div className="max-w-6xl mx-auto">
                        <p className="text-gray-600">
                            Vorstel partners with forward-thinking organizations that understand the value of
                            strategic technology. From global enterprises to fast-moving startups, our
                            clients rely on us to deliver clear, scalable, and impactful digital solutions.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                    <div className="bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl p-6 text-center border border-blue-100">
                        <h3 className="text-4xl font-bold text-blue-600 mb-2">92%</h3>
                        <p className="text-gray-700 font-medium">Faster deployment cycles</p>
                        <p className="text-sm text-gray-500 mt-2">Compared to industry averages</p>
                    </div>
                    <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-6 text-center border border-green-100">
                        <h3 className="text-4xl font-bold text-green-600 mb-2">45%</h3>
                        <p className="text-gray-700 font-medium">Reduction in system downtime</p>
                        <p className="text-sm text-gray-500 mt-2">For our enterprise clients</p>
                    </div>
                    <div className="bg-gradient-to-r from-purple-50 to-violet-50 rounded-xl p-6 text-center border border-purple-100">
                        <h3 className="text-4xl font-bold text-purple-600 mb-2">100%</h3>
                        <p className="text-gray-700 font-medium">Global Trust, Proven Results</p>
                        <p className="text-sm text-gray-500 mt-2">97% client satisfaction across multiple countries.</p>
                    </div>
                </div>


                {/* Improved Company Tabs */}
                <div className="mb-10">
                    <div className="flex flex-wrap justify-center gap-2">
                        {companies.map((comp, idx) => (
                            <button
                                key={idx}
                                onClick={() => setSelected(idx)}
                                className={`flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${selected === idx
                                    ? "bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg shadow-blue-100"
                                    : "bg-white text-gray-600 border border-gray-200 hover:border-gray-300 hover:shadow-sm"
                                    }`}
                            >
                                <span className={`${selected === idx ? "text-white" : "text-gray-500"}`}>
                                    {comp.icon}
                                </span>
                                <span>{comp.name}</span>
                                {selected === idx && (
                                    <span className="ml-1.5 w-2 h-2 bg-white rounded-full opacity-80"></span>
                                )}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Testimonial Section */}
                {/* Enhanced Testimonial Section */}
                <div className="max-w-4xl mx-auto">
                    {/* <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        className="relative"
                    > */}
                    {/* <div className="bg-gradient-to-br from-white to-gray-50 p-8 md:p-10 rounded-xl shadow-md relative border border-gray-100 overflow-hidden"> */}
                    {/* Decorative elements */}
                    {/* <div className="absolute -top-4 -right-4 text-gray-100 z-0">
                                <FaQuoteRight className="text-7xl md:text-8xl" />
                            </div> */}

                    {/* Animated content */}
                    {/* <AnimatePresence mode="wait"> */}
                    <motion.div
                        key={selected}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="relative z-10"
                    >
                        {/* Rating stars */}
                        {/* <div className="flex justify-center mb-5">
                                        {[...Array(5)].map((_, i) => (
                                            <FaStar
                                                key={i}
                                                className="text-yellow-400 mx-1 text-lg md:text-xl"
                                            />
                                        ))}
                                    </div> */}

                        {/* Testimonial quote */}
                        {/* <blockquote className="text-lg md:text-xl text-gray-800 mb-8 text-center font-medium leading-relaxed">
                                        "{company.quote}"
                                    </blockquote> */}

                        {/* Author info */}
                        {/* <div className="text-center">
                                        <p className="font-semibold text-gray-900 text-md md:text-lg">
                                            {company.person}
                                        </p>
                                        <p className="text-sm text-gray-500 mt-1">
                                            {company.designation}
                                        </p>
                                    </div> */}
                    </motion.div>
                    {/* </AnimatePresence> */}

                    {/* Navigation controls */}
                    {/* <div className="flex justify-center mt-8 space-x-4">
                                <button
                                    onClick={prevTestimonial}
                                    className="p-3 rounded-full bg-white shadow-md hover:bg-gray-50 text-gray-600 hover:text-gray-900 transition-all duration-200 border border-gray-200 hover:border-gray-300 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                                    aria-label="Previous testimonial"
                                >
                                    <FaChevronLeft className="text-sm" />
                                </button>
                                <div className="flex items-center space-x-2">
                                    {companies.map((_, idx) => (
                                        <button
                                            key={idx}
                                            onClick={() => setSelected(idx)}
                                            className={`w-2.5 h-2.5 rounded-full transition-all ${selected === idx ? 'bg-blue-600 scale-125' : 'bg-gray-300'}`}
                                            aria-label={`View testimonial ${idx + 1}`}
                                        />
                                    ))}
                                </div>
                                <button
                                    onClick={nextTestimonial}
                                    className="p-3 rounded-full bg-white shadow-md hover:bg-gray-50 text-gray-600 hover:text-gray-900 transition-all duration-200 border border-gray-200 hover:border-gray-300 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                                    aria-label="Next testimonial"
                                >
                                    <FaChevronRight className="text-sm" />
                                </button>
                            </div> */}
                </div>
                {/* </motion.div> */}
            </div>
        </div>
        // </div>
    );
};

export default CompanyTestimonial;